import {Center, Checkbox, Flex, Input, Loader, Select, Text, TextInput} from "@mantine/core";
import { ForwardedRef, useEffect, useState } from "react";
import { SurveyCreator, SurveyCreatorComponent } from "survey-creator-react";
import {
  getApiImpactFrameworkGetImpactFrameworkById,
  getApiImpactFrameworkGetImpactFrameworkSetList,
  getApiStepGetSteps,
  useGetApiImpactFrameworkGetImpactFrameworkById,
  useGetApiImpactFrameworkGetImpactFrameworkSetList,
} from "../../api/endpoints";
import {ImpactFrameworkDTO, Step, StepResult, SubmissionResponse} from "../../api/model";
import { UploadList } from "../../components/UploadList";
import Uploader from "../../components/Uploader";
import Creator from "../../components/calls/text/Creator";
import Filler from "../../components/calls/text/Filler";
import MiniDYI from "../../components/mini DYI/MiniDYI";
import AccordionOutcomes from "../admin/AccordionOutcomes";
import Survey from "../survey/survey";
import "survey-creator-core/survey-creator-core.i18n";
import { editorLocalization } from "survey-creator-core";
import { useTranslation } from "react-i18next";
import useSelectedLanguage from "../../hooks/useSelectedLanguage";
import { useConfig } from "../../hooks/useConfig";
import {MiniDYIOptions} from "../../components/CallStepper";
import useApi from "../../utils/useApi";




export type creationComponentProps = {
  content?: string;
  step?: Step;
  setData: (value: string) => void;
};
export type FillableComponentProps = {
  submission: SubmissionResponse;
  step: Step;
  data?: string;
  setData: (value: string) => Promise<StepResult>;
  currentStepRef?: ForwardedRef<any>;
  readOnly?: boolean;
};

export type creationComponent = React.FC<creationComponentProps>;

export type fillableComponent = React.FC<FillableComponentProps>;

interface IStepsConfig {
  [key: string]: {
    CreationComponent: creationComponent;
    FillableComponent: fillableComponent;
  };
}

const stepsConfig: IStepsConfig = {
  text: {
    CreationComponent: Creator,
    FillableComponent: Filler,
  },
  upload: {
    CreationComponent: Uploader,
    FillableComponent: UploadList,
  },
  miniDyi: {
    CreationComponent: ({ content = "", setData}) => {
      const [selected, setSelected] = useState<string | null>(null);
      const [options, setOptions] = useState<MiniDYIOptions | null>({
        showSdgFilter: true,
        maxOutcomeSelect: 4,
        maxSdgSelect: 4,
      })
      const [first, setFirst] = useState(true)  ;
      console.log("content1", content);
      const { t } = useTranslation();
      const {
        data: frameworks,
        setData: setFrameworks,
        loading: isLoadingFrameworks,
        setLoading: setIsLoadingFrameworks,
        error: errorFrameworks,
        setError: setErrorFrameworks,
      } = useApi<ImpactFrameworkDTO[]>(() => getApiImpactFrameworkGetImpactFrameworkSetList(), [content]);
      const {
        data: item,
        setData: setItem,
        loading: isLoadingItem,
        setLoading: setIsLoadingItem,
        error: errorItem,
        setError: setErrorItem,
      } = useApi<ImpactFrameworkDTO>(() => getApiImpactFrameworkGetImpactFrameworkById({
        ImpactFrameworkId: selected!,
      }), [selected], (selected??"") != "");
      
      // useEffect(() => {
      //   if (!first) {
      //     setData(JSON.stringify(selected));
      //   }else{
      //     setFirst(false);
      //   }
      // }, [selected]);

      useEffect(() => {
        if (content != "") {
          console.log("content", content);
          // console.log("parsed content", JSON.parse(content));
          try{
            let tmp = JSON.parse(content ?? "");
            if (typeof tmp == "string") {
              console.log("tmp1", tmp);
              setSelected(tmp);
              setOptions({
                showSdgFilter: true,
                maxOutcomeSelect: 4,
                maxSdgSelect: 4,
              })
            }else{
              console.log("tmp", tmp);
              setSelected(tmp.frameworkId);
              setOptions(tmp.options);
            }
            
          }catch (e) {
            setSelected("");
            setOptions({
              showSdgFilter: true,
              maxOutcomeSelect: 4,
              maxSdgSelect: 4,
            })
          }
          
        }
      }, []);
      console.log("frameworks", frameworks);
      if (isLoadingFrameworks || isLoadingItem || errorFrameworks || errorItem || frameworks === null) {
        return (<Center>
          <Loader />
        </Center>);
      }
      return (
        <>
          <Flex align="center">
            <Text> {t("enable-sdg-filter")}:</Text>
            <Checkbox
                m={10}
                mr={20}
                checked={
                  options!.showSdgFilter ?? false
                }
                onChange={(e) => {
                  let newOpt = {...options!, showSdgFilter: e.target.checked}
                  setOptions(newOpt);
                  console.log("e", e);
                  setData(JSON.stringify({frameworkId: selected, options: newOpt}));
                }}

            ></Checkbox>
            
          </Flex>
          <Flex align="center" hidden={!options!.showSdgFilter ?? false}>
            <Text>{t("max-sdg-number")}:</Text>
            <Input
                m={10}
                mr={20}
                value={
                    options!.maxSdgSelect ?? 4
                }
                onChange={(e:any) => {
                  let newOpt = {...options!, maxSdgSelect: e.target.value}
                  setOptions(newOpt);
                  // console.log("e", e);
                  setData(JSON.stringify({frameworkId: selected, options: newOpt}));
                }}

            ></Input>

          </Flex>
          <Flex align="center">
            <Text>{t("max-outcome-number")}:</Text>
            <Input
                m={10}
                mr={20}
                value={
                    options!.maxOutcomeSelect ?? 4
                }
                onChange={(e:any) => {
                  let newOpt = {...options!, maxOutcomeSelect: e.target.value}
                  setOptions(newOpt);
                  // console.log("e", e);
                  setData(JSON.stringify({frameworkId: selected, options: newOpt}));
                }}

            ></Input>

          </Flex>
          <Flex align="center">
            <Text>
              {t("framework-select")}
            </Text>
          <Select
            value={selected}
            onChange={(e: any) => {
              setSelected(e);
              console.log("options", options);
              setData(JSON.stringify({frameworkId: e, options: options!}));
            }}
            data={frameworks!.map((e: any) => ({ value: e.id, label: e.name }))}
            placeholder={"Framework"}
          />
          </Flex>
          {item && <AccordionOutcomes framework={item} />}
        </>
      );
    },
    FillableComponent: ({ step, setData, currentStepRef, readOnly }) => {
      const SetDataIfNotReadOnly = (value: string) => {
        if (!readOnly) {
          return setData(value);
        }
        return Promise.resolve({} as StepResult);
      }
      var ifid = ""
      var opt: MiniDYIOptions = {
        showSdgFilter: true,
        maxOutcomeSelect: 4,
        maxSdgSelect: 4,
      }
      try{
        
      let tmp = JSON.parse(step.content!);
      if (typeof tmp == "string") {
        ifid = tmp;
        
      }else{
        ifid = tmp.frameworkId;
        opt = tmp.options;
      }
      }catch (e){
        ifid = step.content!
      }
      
      return <MiniDYI
          step={step}
          setData={SetDataIfNotReadOnly}
          impactFrameworkId={ifid}
          ref={currentStepRef}
          readOnly={readOnly}
          options={opt}
      ></MiniDYI>
    },
  },
  results: {
    CreationComponent: ({ content = "", setData = () => null }) => {
      return (
        <TextInput value={content} onChange={(e) => setData(e.target.value)} />
      );
    },
    FillableComponent: ({ step }) => <Text size="lg">{step.content}</Text>,
  },
  survey: {
    CreationComponent: ({ content, setData }) => {
      const { t } = useTranslation();
      // const [selectedLanguage, setSelectedLanguage] = useSelectedLanguage();
      const config = useConfig();

      // const config = useConfig();
      useEffect(() => {
        // console.log("selectedLanguage", config.defaultLanguage);
        editorLocalization.currentLocale = config.defaultLanguage ?? "en";
            // i18n.changeLanguage(config.defaultLanguage ?? selectedLanguage ?? "en");
      }, []);


      const creatorOptions = {
        showLogicTab: true,
        isAutoSave: true,
        haveCommercialLicense: true,
        
      };
      const creator = new SurveyCreator(creatorOptions);
      //@ts-ignore
      useEffect(() => {
        creator.text = content!;
      }, []);
      creator.saveSurveyFunc = (saveNo: any, callback: any) => {
        setData(creator.text);
        callback(saveNo, true);
      };
      return (
        <>
        <Text size={"lg"} mb={8} weight={"bold"} bg={"#ff28284d"}>
          {t("pages.admin.sjeditordisclaimer")}
        </Text>
          <SurveyCreatorComponent creator={creator}></SurveyCreatorComponent>
        </>
      );
    },
    FillableComponent: ({ step, setData, currentStepRef, readOnly }) => {
      const SetDataIfNotReadOnly = (value: string) => {
        if (!readOnly) {
          return setData(value);
        }
        return Promise.resolve({} as StepResult);
      }
      return <Survey
          model={step.content!}
          setData={SetDataIfNotReadOnly}
          step={step}
          ref={currentStepRef}
          readOnly={readOnly}
      ></Survey>
    },
  },
  quiz: {
    CreationComponent: ({ content, setData }) => {
      const creatorOptions = {
        showLogicTab: false,
        isAutoSave: true,
        haveCommercialLicense: true,
      };
      const creator = new SurveyCreator(creatorOptions);
      creator.text = content!;
      creator.saveSurveyFunc = (saveNo: any, callback: any) => {
        setData(creator.text);
        callback(saveNo, true);
      };
      return (
        <>
          <SurveyCreatorComponent creator={creator}></SurveyCreatorComponent>
        </>
      );
    },
    FillableComponent: ({ step, setData, currentStepRef, readOnly }) => {
      const SetDataIfNotReadOnly = (value: string) => {
        if (!readOnly) {
          return setData(value);
        }
        return Promise.resolve({} as StepResult);
      }
      return <Survey
          model={step.content!}
          setData={SetDataIfNotReadOnly}
          step={step}
          isQuiz={true}
          ref={currentStepRef}
          readOnly={readOnly}
      ></Survey>
    },
  },
};
export default stepsConfig;
